import { render, staticRenderFns } from "./EditarAtencion.vue?vue&type=template&id=6d69e038"
import script from "./EditarAtencion.vue?vue&type=script&lang=js"
export * from "./EditarAtencion.vue?vue&type=script&lang=js"
import style0 from "./EditarAtencion.vue?vue&type=style&index=0&id=6d69e038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports